export default __webpack_public_path__ + "static/media/payment.18c76346.gif";